import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar los archivos de traducción
import es from './locales/es.json';
import en from './locales/en.json';
import cr from './locales/cr.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: es
      },
      en: {
        translation: en
      },
      cr: {
        translation: cr
      }
    },
    lng: 'en', // Idioma por defecto
    fallbackLng: 'en', // Si no encuentra la traducción, usa español
    interpolation: {
      escapeValue: false // react ya hace la protección XSS
    }
  });

export default i18n;